import { useLazyQuery } from '@apollo/client';
import { useAuth } from 'contexts/AuthContext';
import { selectConfiguration } from 'features/configuration/slice/selectors';
import { GET_PENDING_QUIZZES_RESPONSE, GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    setBodyShapeDefault,
    setBodyTypeDefault,
    setMyBirthday,
    setPersonaDefault,
    setSkinToneDefault,
    setSkinUndertoneDefault,
    setHairColorDefault,
    setEyeColorDefault,
    setStyleQuizLiked,
    setFashionRestrictionDefault,
    setBudgetDefault,
    setPendingQuizzes as setPendingQuizzesOnRedux,
} from 'redux/authentication/user_detail';
import { globalActions } from 'redux/global/global.slice';
import { getListAnswerPersonas } from 'redux/quiz_manager/personasSlice';
import { setCurrentQuizId, setQuestion, setQuizConfig, setEndQuiz } from 'redux/quiz_manager/quizSlice';
import { useAppDispatch } from 'redux/store';
import { PATH } from 'routes/constant';
import { EGENDER, EQuestionId, EQuizId, ESubjectQuestion, ETemplateTypes, quizContextType } from 'types/quiz';
import { createFilterList, getAnsweredQuestions, renderItem, renderListStyleQuizLiked } from 'utils/convertListString';
import { RootState } from '../../redux/store';
import { identify } from '../../utils/analytics';
import BodyShapeQuiz from './body_shape_body_type/body_shape_quiz';
import BodyTypeQuiz from './body_shape_body_type/body_type_quiz';
import SkinTone from './color_list_multi/skin_tone';
import ColorsQuiz from './color_quiz/color_quiz';
import ImageSingleSelect from './image_single_select';
import IntroQuizPage from './welcome_screens/intro_quiz';
import MyBirthDayQuiz from './my_birthday/my_birthday';
import MyPhotos from './my_photos/my_photos';
import Pattern from './pattern_quiz';
import ShowOffQuiz from './show_off';
import StylesRequestContainer from './personas/style_request';
import { quiz_data } from './setup_quiz';
import SizesQuiz from './size_list/sizes';
import StyleQuiz from './style_quiz/style_quiz';
import SkinUndertone from './skin_undertone/SkinUndertone';
import HairColor from './hair_color/HairColor';
import EyeColor from './eye_color/EyeColor';
import { getSearchKey } from '__generated__/getSearchKey';
import { GET_SEARCH_KEY } from 'graph_ql/search/get_search_key.gql';
import { setSetSearchKey } from 'features/algolia/slice';
import FashionRestriction from './fashion_restriction';
import BudgetQuiz from './budget_quiz';
import HijabQuiz from './hijab/HijabQuiz';
import Measurements from './measurements/index';
import Cover from './cover';
import CompleteQuizPage from './welcome_screens/complete_quiz';
import SocialMedia from './social_media/social_media';
import utils from 'utils/utils';
import { QuizSpinner } from 'component/layout_quiz/quiz-spinner';

export enum UserQuizStatus {
    done = 'done',
    pending = 'pending',
    skip = 'skip',
}
interface pendingQuiz {
    quizId: EQuizId;
    conditionQuiz: boolean | null;
    status: UserQuizStatus;
}

function QuizManager() {
    const history = useHistory();
    const { currentUser } = useAuth();
    const dispatch = useAppDispatch();
    const dataConfig = useSelector(selectConfiguration);
    const quiz = useSelector((state: RootState) => state.quiz.quizes);
    const pendingQuizObj = useSelector((state: RootState) => state.userDetail.pendingQuizzes);
    const endQuiz = useSelector((state: RootState) => state.quiz.endQuiz);
    const spinnerLoading = useSelector((state: RootState) => state.global.spinnerLoading);
    const [quizId, setQuizId] = useState(quiz?.gender?.common || dataConfig?.quizes?.gender?.common);
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const question = useSelector((state: RootState) => state.quiz.questions);
    const [dataQues, setDataQues] = useState<any | undefined>(null);
    const [hasIdentified, setHasIdentified] = useState<boolean>(false);
    const [isSignUp, setIsSignUp] = useState(false);
    const [isUserAttendingQuiz, setIsUserAttendingQuiz] = useState(false);
    const [renderCompleteQuiz, setRenderCompleteQuiz] = useState(false);
    const [isMultiQuesAnswering, setIsMultiQuesAnswering] = useState<Boolean>(false);
    const [pendingQuizzes, setPendingQuizzes] = useState<pendingQuiz[] | []>([]);

    const triggerIdentify = (gender) => {
        if (!hasIdentified) {
            identify(userDetail.uid, {
                gender,
                firstName: userDetail.firstName,
                lastName: userDetail.lastName,
                name: userDetail.firstName + ' ' + userDetail.lastName,
                phone: userDetail.phone,
            });
            setHasIdentified(true);
        }
    };
    console.debug(`quizId`, quizId, quiz);

    const [getSearchKeyFuc] = useLazyQuery<getSearchKey, any>(GET_SEARCH_KEY, {
        fetchPolicy: 'network-only',
        context: {
            scope: 'private',
            approved: true,
        },
    });

    const [getPendingQuizzes, { loading: pendingQuizLoading }] = useLazyQuery(GET_PENDING_QUIZZES_RESPONSE, {
        fetchPolicy: 'network-only',
        onCompleted(data) {
            if (data?.getPendingQuizzes?.quizConfigs?.length) {
                const userQuizzes = data?.getPendingQuizzes?.quizConfigs;
                const conditionQuiz = userQuizzes.find((item) => item.conditionQuiz);
                const pendingQuizList =
                    userQuizzes && userQuizzes?.filter((item) => item.status === UserQuizStatus.pending);
                const completedQuizList =
                    userQuizzes &&
                    userQuizzes?.filter(
                        (item) => item.status === UserQuizStatus.done || item.status === UserQuizStatus.skip,
                    );
                if (!_.isEmpty(conditionQuiz)) {
                    setIsSignUp(true);
                    getQuizResponse(getQuizVariable(conditionQuiz?.quizId));
                } else if (pendingQuizList.length) {
                    setPendingQuizzes(pendingQuizList);
                } else if (completedQuizList.length === userQuizzes.length) {
                    completeQuizProcess();
                }
            }
            dispatch(setPendingQuizzesOnRedux(data));
        },
        onError() {
            console.log('pendingQuiz error');
        },
    });

    useEffect(() => {
        if (pendingQuizzes.length) {
            const nextPendingQuiz = pendingQuizzes.find((item) => item.status === UserQuizStatus.pending);
            if (nextPendingQuiz?.quizId) {
                getQuizResponse(getQuizVariable(nextPendingQuiz?.quizId));
            } else {
                renderCompleteQuizScreen();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingQuizzes]);

    const endLoading = useCallback(
        (isQuizCompleted = false) => {
            if (isQuizCompleted) {
                dispatch(
                    globalActions.setSpinnerLoading([
                        ...spinnerLoading.filter((item) => item !== 'quizManager'),
                        'loadingHome',
                    ]),
                );
            } else {
                dispatch(globalActions.setSpinnerLoading(spinnerLoading.filter((item) => item !== 'quizManager')));
            }
        },
        [dispatch, spinnerLoading],
    );

    const completeQuizProcess = useCallback(() => {
        const handleRedirect = () => {
            if (utils.isAppInWidgetMode() && JSON.parse(sessionStorage.getItem('widgetSignupCompleted')!)) {
                sessionStorage.removeItem('widgetSignupCompleted');
            }
            endLoading(true);
            dispatch(globalActions.setLoadingHome(true));
            history.push(PATH.STYLE_ASSISTANT);
        };
        const algoliaToken = localStorage.getItem('ALGOLIA_TOKEN');

        if (!algoliaToken) {
            getSearchKeyFuc().then((res) => {
                localStorage.setItem('ALGOLIA_TOKEN', res?.data?.getSearchKey?.token || '');
                dispatch(setSetSearchKey(res?.data?.getSearchKey?.token || ''));
                handleRedirect();
            });
        } else {
            handleRedirect();
        }
    }, [dispatch, endLoading, history, getSearchKeyFuc]);

    const getValueQuizVariable = useCallback(
        (displayOder: number, gender?: EGENDER) => {
            const currentQuiz = quiz_data.find((item) => item.displayOrder === displayOder && item.gender === gender);
            if (currentUser && currentUser.uid) {
                return {
                    variables: {
                        input: {
                            quizId: currentQuiz?.id,
                            contextType: quizContextType,
                            contextId: currentQuiz?.id,
                            userId: currentUser.uid || userDetail.id,
                        },
                        state: Math.random(),
                    },
                };
            }
        },
        [currentUser, userDetail.id],
    );
    const getQuizVariable = useCallback(
        (quizId: EQuizId) => {
            if (currentUser && currentUser.uid) {
                return {
                    variables: {
                        input: {
                            quizId: quizId,
                            contextType: quizContextType,
                            contextId: quizId,
                            userId: currentUser.uid || userDetail.id,
                        },
                        state: Math.random(),
                    },
                };
            }
        },
        [currentUser, userDetail.id],
    );

    const updateAnsweredQuiz = (quizId) => {
        const updatedPendingQuizList = pendingQuizzes.map((item) => {
            if (item.quizId === quizId) {
                return { ...item, status: UserQuizStatus.done };
            }
            return item;
        });
        const userQuizzes = pendingQuizObj?.getPendingQuizzes?.quizConfigs || [];
        const updatedUserQuizList = userQuizzes.map((item) => {
            if (item.quizId === quizId) {
                return { ...item, status: UserQuizStatus.done };
            }
            return item;
        });
        const updateUserQuizObj = { getPendingQuizzes: { quizConfigs: updatedUserQuizList } };
        setPendingQuizzes(updatedPendingQuizList);
        dispatch(setPendingQuizzesOnRedux(updateUserQuizObj));
    };

    const endQuizManually = useCallback(() => {
        const updatedPendingQuizList = pendingQuizzes.map((item) => {
            return { ...item, status: UserQuizStatus.done };
        });
        const userQuizzes = pendingQuizObj?.getPendingQuizzes?.quizConfigs || [];
        const updatedUserQuizList = userQuizzes.map((item) => {
            return { ...item, status: UserQuizStatus.done };
        });
        const updateUserQuizObj = { getPendingQuizzes: { quizConfigs: updatedUserQuizList } };
        setPendingQuizzes(updatedPendingQuizList);
        dispatch(setPendingQuizzesOnRedux(updateUserQuizObj));
        completeQuizProcess();
    }, [completeQuizProcess, dispatch, pendingQuizObj?.getPendingQuizzes?.quizConfigs, pendingQuizzes]);

    useEffect(() => {
        if (endQuiz) {
            endQuizManually();
            dispatch(setEndQuiz(false));
        }
    }, [endQuiz, endQuizManually, dispatch]);

    const renderCompleteQuizScreen = () => {
        if (isUserAttendingQuiz) {
            setRenderCompleteQuiz(true);
        } else {
            completeQuizProcess();
        }
    };

    const handleQuizView = (questions) => {
        endLoading(false);
        setIsUserAttendingQuiz(true);
        dispatch(setQuestion(questions));
    };
    const [getQuizResponse, { loading: quizResponseLoading }] = useLazyQuery(GET_QUIZ_RESPONSE, {
        fetchPolicy: 'network-only',
        onCompleted(data) {
            if (!data.getQuizResponse || _.isNull(data.getQuizResponse)) history.push(PATH.PATH_NOT_FOUND);
            const answers = data?.getQuizResponse?.answers;
            const questions = data?.getQuizResponse?.questions;
            if (questions?.length)
                localStorage.setItem('questionInfo', JSON.stringify(Object.entries(questions)[0][1]));
            dispatch(setCurrentQuizId(data.getQuizResponse?.id));
            switch (data.getQuizResponse?.id) {
            case EQuizId.GENDER_QUIZ:
                if (Object.keys(answers).length > 0) {
                    getPendingQuizzes();
                    triggerIdentify(answers?.gender_question.value);
                    setIsSignUp(false);
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.MY_BIRTHDAY_QUIZ:
                if (Object.keys(answers).length > 0) {
                    updateAnsweredQuiz(EQuizId.MY_BIRTHDAY_QUIZ);
                    dispatch(setMyBirthday(answers?.birthday_question.value));
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.PERSONAS_MALE_QUIZ:
                if (Object.keys(answers).length > 0) {
                    dispatch(getListAnswerPersonas(renderItem(answers?.personas_male_question?.value)));
                    dispatch(setPersonaDefault(createFilterList(answers?.personas_male_question?.value)));
                    updateAnsweredQuiz(EQuizId.PERSONAS_MALE_QUIZ);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.PERSONAS_FEMALE_QUIZ:
                if (Object.keys(answers).length > 0) {
                    dispatch(getListAnswerPersonas(renderItem(answers?.personas_female_question?.value)));
                    dispatch(setPersonaDefault(createFilterList(answers?.personas_female_question?.value)));
                    updateAnsweredQuiz(EQuizId.PERSONAS_FEMALE_QUIZ);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.BODY_SHAPE:
                if (Object.keys(answers).length > 0) {
                    dispatch(setBodyShapeDefault(answers?.body_shape_question.value));
                    updateAnsweredQuiz(EQuizId.BODY_SHAPE);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.BODY_TYPE:
                if (Object.keys(answers).length > 0) {
                    dispatch(setBodyTypeDefault(answers?.body_type_question.value));
                    updateAnsweredQuiz(EQuizId.BODY_TYPE);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.SKIN_TONE:
                if (Object.keys(answers).length > 0) {
                    dispatch(setSkinToneDefault(answers?.skintone_question));
                    updateAnsweredQuiz(EQuizId.SKIN_TONE);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;

            case EQuizId.SKIN_UNDERTONE:
                if (Object.keys(answers).length > 0) {
                    dispatch(setSkinUndertoneDefault(answers?.skin_undertone_question));
                    updateAnsweredQuiz(EQuizId.SKIN_UNDERTONE);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.HAIR_COLOR:
                if (Object.keys(answers).length > 0) {
                    dispatch(setHairColorDefault(answers?.hair_color_question));
                    updateAnsweredQuiz(EQuizId.HAIR_COLOR);
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.EYE_COLOR:
                if (Object.keys(answers).length > 0) {
                    getPendingQuizzes();
                    dispatch(setEyeColorDefault(answers?.eye_color_question));
                    updateAnsweredQuiz(EQuizId.EYE_COLOR);
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.MEASUREMENTS_QUIZ_MALE:
            case EQuizId.MEASUREMENTS_QUIZ_FEMALE:
                if (
                    Object.keys(answers).length > 0 &&
                        (_.valuesIn(answers).length === _.valuesIn(questions).length ||
                            _.valuesIn(questions).length === 0)
                ) {
                    updateAnsweredQuiz(data.getQuizResponse?.id);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.MY_PHOTOS_QUIZ:
                if (Object.keys(answers).length > 0) {
                    updateAnsweredQuiz(data.getQuizResponse?.id);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.STYLE_QUIZ_MAN:
                if (Object.keys(answers).length > 0) {
                    dispatch(setStyleQuizLiked(renderListStyleQuizLiked(answers, questions)));
                    if (
                        (_.valuesIn(answers).length === _.valuesIn(questions).length ||
                                _.valuesIn(questions).length === 0) &&
                            !isMultiQuesAnswering
                    ) {
                        updateAnsweredQuiz(data.getQuizResponse?.id);
                        getPendingQuizzes();
                    } else {
                        setIsMultiQuesAnswering(true);
                        handleQuizView(questions);
                    }
                } else {
                    setIsMultiQuesAnswering(true);
                    handleQuizView(questions);
                }
                break;
            case EQuizId.STYLE_QUIZ_WOMAN:
                if (Object.keys(answers).length > 0) {
                    dispatch(setStyleQuizLiked(renderListStyleQuizLiked(answers, questions)));
                    if (
                        (_.valuesIn(answers).length === _.valuesIn(questions).length ||
                                _.valuesIn(questions).length === 0) &&
                            !isMultiQuesAnswering
                    ) {
                        updateAnsweredQuiz(data.getQuizResponse?.id);
                        getPendingQuizzes();
                    } else {
                        setIsMultiQuesAnswering(true);
                        handleQuizView(questions);
                    }
                } else {
                    setIsMultiQuesAnswering(true);
                    handleQuizView(questions);
                }
                break;
            case EQuizId.COLOR_QUIZ:
                if (Object.keys(answers).length > 0) {
                    if (
                        _.valuesIn(answers).length === _.valuesIn(questions).length ||
                            _.valuesIn(questions).length === 0
                    ) {
                        updateAnsweredQuiz(data.getQuizResponse?.id);
                        getPendingQuizzes();
                    } else {
                        handleQuizView(questions);
                    }
                } else {
                    handleQuizView(questions);
                }
                break;

            case EQuizId.PATTERN_QUIZ_MAN:
            case EQuizId.PATTERN_QUIZ_WOMAN:
                if (_.valuesIn(answers).length === _.valuesIn(questions).length) {
                    updateAnsweredQuiz(data.getQuizResponse?.id);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.HIJAB:
                if (_.valuesIn(answers).length === _.valuesIn(questions).length) {
                    updateAnsweredQuiz(data.getQuizResponse?.id);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.SHOW_OFF:
                if (_.valuesIn(answers).length > 0) {
                    updateAnsweredQuiz(data.getQuizResponse?.id);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.COVER:
                if (_.valuesIn(answers).length > 0) {
                    updateAnsweredQuiz(data.getQuizResponse?.id);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.FASHION_RESTRICTION_QUIZ_MAN:
            case EQuizId.FASHION_RESTRICTION_QUIZ_WOMAN:
                if (
                    _.valuesIn(answers).length === _.valuesIn(questions).length ||
                        _.valuesIn(questions).length === 0
                ) {
                    dispatch(setFashionRestrictionDefault(getAnsweredQuestions(answers, questions)));
                    updateAnsweredQuiz(data.getQuizResponse?.id);
                    getPendingQuizzes();
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.SIZES_MALE:
            case EQuizId.SIZE_FEMALE:
                if (Object.keys(answers).length > 0) {
                    if (
                        _.valuesIn(answers).length === _.valuesIn(questions).length ||
                            _.valuesIn(questions).length === 0
                    ) {
                        updateAnsweredQuiz(data.getQuizResponse?.id);
                        getPendingQuizzes();
                    } else {
                        handleQuizView(questions);
                    }
                } else {
                    handleQuizView(questions);
                }
                break;
            case EQuizId.BUDGET_MAN_QUIZ:
            case EQuizId.BUDGET_WOMAN_QUIZ:
                if (Object.keys(answers).length > 0) {
                    dispatch(setBudgetDefault(getAnsweredQuestions(answers, questions)));
                    if (
                        (_.valuesIn(answers).length === _.valuesIn(questions).length && !isMultiQuesAnswering) ||
                            _.valuesIn(questions).length === 0
                    ) {
                        updateAnsweredQuiz(data.getQuizResponse?.id);
                        getPendingQuizzes();
                    } else {
                        setIsMultiQuesAnswering(true);
                        handleQuizView(questions);
                    }
                } else {
                    setIsMultiQuesAnswering(true);
                    handleQuizView(questions);
                }
                break;
            case EQuizId.SOCIAL_MEDIA_QUIZ:
                if (Object.keys(answers).length > 0) {
                    if (
                        _.valuesIn(answers).length === _.valuesIn(questions).length ||
                            _.valuesIn(questions).length === 0
                    ) {
                        updateAnsweredQuiz(data.getQuizResponse?.id);
                        getPendingQuizzes();
                    } else {
                        handleQuizView(questions);
                    }
                } else {
                    handleQuizView(questions);
                }
                break;
            default:
                return;
            }
        },
        onError() {
            history.push(PATH.PATH_NOT_FOUND);
        },
    });

    const handleNext = useCallback(
        (value: Boolean, order?: number, gender?: EGENDER) => {
            setIsMultiQuesAnswering(value);
            if (!value && order && gender) {
                getQuizResponse(getValueQuizVariable(order, gender));
            } else if (!value && order) {
                getQuizResponse(getValueQuizVariable(order));
            }
        },
        [getQuizResponse, getValueQuizVariable],
    );

    useEffect(() => {
        if (currentUser && currentUser.uid) {
            // if (!utils.isAppInWidgetMode()) startLoading();
            getPendingQuizzes();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser]);

    useEffect(() => {
        if (dataConfig?.quizes?.gender?.common) {
            setQuizId(dataConfig?.quizes?.gender?.common);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataConfig]);

    useEffect(() => {
        if (dataConfig && dataConfig && userDetail.id) {
            dispatch(setQuizConfig(dataConfig));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataConfig, userDetail]);
    useEffect(() => {
        if (question) {
            setDataQues(Object.entries(question)[0][1]);
        }
    }, [question]);

    // const startLoading = () => {
    //     dispatch(globalActions.setSpinnerLoading([...spinnerLoading, 'quizManager']));
    // };
    if (pendingQuizLoading || quizResponseLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <QuizSpinner />
            </div>
        );
    }
    if (dataQues && dataQues?.templateType) {
        if (isSignUp) {
            return <IntroQuizPage setIsSignUp={setIsSignUp} />;
        }
        if (renderCompleteQuiz) {
            return <CompleteQuizPage completeQuizProcess={completeQuizProcess} />;
        }
        switch (dataQues?.templateType) {
        case ETemplateTypes.IMAGE_SINGLE_SELECT:
            if (dataQues.questionDataSubject === ESubjectQuestion.BODY_SHAPE_SUBJECT_QUESTION) {
                return <BodyShapeQuiz title={dataQues.title} completeQuizProcess={endQuizManually} />;
            } else if (dataQues.questionDataSubject === ESubjectQuestion.BODY_TYPE_SUBJECT_QUESTION) {
                return <BodyTypeQuiz title={dataQues.title} />;
            } else {
                return <ImageSingleSelect />;
            }
        case ETemplateTypes.NORMAL:
            if (dataQues.id === EQuestionId.MY_BIRTHDAY) return <MyBirthDayQuiz />;
            else if (dataQues.id === EQuestionId.SKIN_TONE) return <SkinTone />;
            else if (dataQues.id === EQuestionId.SKIN_UNDERTONE) return <SkinUndertone />;
            else if (dataQues.id === EQuestionId.HAIR_COLOR) return <HairColor />;
            else if (dataQues.id.includes(EQuestionId.SIZES)) return <SizesQuiz handleNext={handleNext} />;
            else if (dataQues.id === EQuestionId.EYE_COLOR) return <EyeColor />;
            else if (dataQues.id.includes(EQuestionId.COLOR)) return <ColorsQuiz />;
            else if (dataQues.id === EQuestionId.PATTERN) return <Pattern />;
            else if (dataQues.id === EQuestionId.SHOW_OFF) return <ShowOffQuiz />;
            else if (dataQues.id === EQuestionId.COVER) return <Cover />;
            else if (dataQues.id.includes(EQuestionId.HIJAB)) return <HijabQuiz />;
            else if (dataQues.id.includes(EQuestionId.MEASUREMENTS))
                return <Measurements handleNext={handleNext} />;
            else if (dataQues.id.includes(EQuestionId.SOCIAL_MEDIA)) return <SocialMedia />;
            else return <StylesRequestContainer />;
        case ETemplateTypes.STYLE_QUIZ:
            return <StyleQuiz handleNext={handleNext} />;
        case ETemplateTypes.GRID:
            return <MyPhotos />;
        case ETemplateTypes.LIST:
            if (dataQues.id === EQuestionId.FASHION_RESTRICTION) {
                return <FashionRestriction />;
            }
            return <BudgetQuiz handleNext={handleNext} />;
        default:
            return null;
        }
    }
    return <></>;
}

export default QuizManager;
